import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import MergeReviewView from './MergeReviewView';

const route: FuseRouteItemType = {
	path: 'catalog/merge-review',
	element: <MergeReviewView />
};

export default route;
